<template>
  <div class="row g-2">
    <!-- Select Day -->
    <div class="col">
      <select id="day" v-model="selectedDay" class="form-select">
        <option disabled value="">Pilih Hari</option>
        <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
      </select>
    </div>

    <!-- Select Month -->
    <div class="col">
      <select id="month" v-model="selectedMonth" class="form-select">
        <option disabled value="">Pilih Bulan</option>
        <option
          v-for="(month, index) in months"
          :key="index"
          :value="index + 1"
        >
          {{ month }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
});

const selectedDay = ref("");
const selectedMonth = ref("");

const days = Array.from({ length: 31 }, (_, i) => i + 1);

const months = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

const emit = defineEmits(["update:modelValue"]);
watch([selectedDay, selectedMonth], () => {
  if (selectedDay.value && selectedMonth.value) {
    const value = `${selectedDay.value
      .toString()
      .padStart(2, "0")}-${selectedMonth.value.toString().padStart(2, "0")}`;
    emit("update:modelValue", value);
  }
});

watch(
  () => props.modelValue,
  (value) => {
    if (value && typeof value === "string") {
      const [dayStr, monthStr] = value.split("-");
      selectedDay.value = parseInt(dayStr);
      selectedMonth.value = parseInt(monthStr);
    }
  },
  { immediate: true }
);
</script>
